<div class="advance-filter" aria-label="Keyword result filters">
    <div class="filter-actions">
        <button class="filter-btn advance-filter-btn p-button-text" type="button" pButton (click)="onToggleAdvanceFilter($event)" aria-haspopup="dialog">
            <i class="pi pi-filter" aria-hidden="true"></i>
            <span>Advanced Filters</span>
            <span *ngIf="activeFilterCount" class="filter-count" aria-label="active filters">{{ activeFilterCount }}</span>
        </button>
        <button *ngIf="activeFilterCount" class="filter-btn clear-filter-btn p-button-text" type="button" pButton label="Clear All" (click)="onClearAdvanceFilter($event)"></button>
    </div>
    <div *ngIf="advanceFilterMessage" class="filter-summary" aria-live="polite">
        <i class="pi pi-check-circle" aria-hidden="true"></i>
        <span>{{ advanceFilterMessage }}</span>
    </div>
</div>

<p-overlayPanel #af styleClass="advanced-filter-panel" [dismissable]="true" [showCloseIcon]="false">
    <ng-template pTemplate>
        <section class="filter-panel-content" role="dialog" aria-modal="false" aria-labelledby="advanced-filter-title">
            <header class="filter-panel-header">
                <div>
                    <h3 id="advanced-filter-title">Advanced Filters</h3>
                    <p>Show keywords that match the rules below.</p>
                </div>
                <button type="button" class="panel-close" pButton icon="pi pi-times" aria-label="Close without applying" (click)="onCancelAdvanceFilter()"></button>
            </header>
            <query-builder [(ngModel)]="draftRuleset" [config]="qbConfig">
                <ng-container *queryOperator="let rule; let operators = operators; let onChange = onChange">
                    <select class="q-operator-control friendly-operator-select"
                            [(ngModel)]="rule.operator"
                            (ngModelChange)="onChange()"
                            aria-label="Filter comparison">
                        <option *ngFor="let operator of operators" [ngValue]="operator">
                            {{ qbProcessor.getOperatorLabel(operator) }}
                        </option>
                    </select>
                </ng-container>
            </query-builder>
            <footer class="filter-panel-footer">
                <button type="button" pButton class="p-button-text" label="Cancel" (click)="onCancelAdvanceFilter()"></button>
                <button type="button" pButton label="Apply Filters" (click)="onApplyAdvanceFilter()"></button>
            </footer>
        </section>
    </ng-template>
</p-overlayPanel>
